import Customers from '@/components/customer/customer-list';
import CustomerCreate from '@/components/customer/customer-create';
import CustomerUpdate from '@/components/customer/customer-update';

const routes = [
    {
        path: '/customers',
        name: 'customers',
        component: Customers,
        meta: {
            breadcrumb: [
                {
                    text: 'Home',
                    to: { name: 'home' }
                },
                { text: 'Customers' }
			],
			requiresAuth: true,
        }
    },
    {
        path: '/customers/create',
        name: 'customercreate',
        component: CustomerCreate,
        meta: {
            breadcrumb: [
                {
                    text: 'Home',
                    to: { name: 'home' }
                },
                {
                    text: 'Customers',
					href: 'javascript:history.back()',
                },
                { text: 'Create' }
			],
			requiresAuth: true,
        }
    },
    {
        path: '/customers/:id/update',
        name: 'customerupdate',
        component: CustomerUpdate,
        meta: {
            breadcrumb: [
                {
                    text: 'Home',
                    to: { name: 'home' }
                },
                {
                    text: 'Customers',
					href: 'javascript:history.back()',
                },
                { text: 'Edit' }
			],
			requiresAuth: true,
        }
    },
];

export default routes;


// WEBPACK FOOTER //
// ./src/components/customer/routes/index.js